import { render, staticRenderFns } from "./CustomCardEffects.vue?vue&type=template&id=ced831bc&scoped=true"
import script from "./CustomCardEffects.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCardEffects.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomCardEffects.vue?vue&type=style&index=0&id=ced831bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced831bc",
  null
  
)

export default component.exports